import { cn } from 'src/shared/utils/cn'

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-muted/20', className)} {...props} />
}

export { Skeleton }
